import { TCategoryFormData } from 'src/@types';
import { ICategorySFilter } from 'src/@types/SearchFilterTypes';
import { ICategory } from 'src/models';
import { TApiResponseData } from 'src/service/apiTypes';
import instance from 'src/service/axios';
import { HEADERS_MULTIPART } from 'src/static/constants';
import objectToQueryString from 'src/utils/objectToQueryString';

const SUB_URL = '/v1/category';

const convertDataInfoToFormData = (data: TCategoryFormData) => {
  const formData = new FormData();

  if (data.categorySid) {
    formData.append('categorySid', data.categorySid.toString());
  }

  // 기본 필드 추가
  const appendField = (key: string, value: any) => {
    if (value !== undefined && value !== null) {
      formData.append(key, String(value));
    }
  };

  // 필수 필드
  appendField('categoryPsid', data.categoryPsid || 0);
  appendField('useYn', data.useYn);
  appendField('ordr', data.ordr);
  appendField('ctgyDpTypeCd', data.ctgyDpTypeCd);

  // 썸네일 처리
  if (data.thumbnail) {
    formData.append('thumbnail', data.thumbnail);
  }
  if (data.thumbnailPath) {
    formData.append('thumbnailPath', data.thumbnailPath);
  }
  // 데스크탑 배경이미지 처리
  if (data.desktopImageFile) {
    formData.append('desktopImageFile', data.desktopImageFile);
  }
  if (data.bgDesktopPath) {
    formData.append('bgDesktopPath', data.bgDesktopPath);
  }
  // 모바일 배경이미지 처리
  if (data.mobileImageFile) {
    formData.append('mobileImageFile', data.mobileImageFile);
  }
  if (data.bgMobilePath) {
    formData.append('bgMobilePath', data.bgMobilePath);
  }
  if (data.deleteFilePaths) {
    data.deleteFilePaths.forEach((path) => {
      formData.append('deleteFilePaths', path);
    });
  }
  // 카테고리 정보 리스트 처리
  data.categoryInfoList?.forEach((info, index) => {
    Object.entries(info).forEach(([key, value]) => {
      appendField(`categoryInfoList[${index}].${key}`, value);
    });
  });

  return formData;
};

/**
 * 사업 목록 조회
 */
export const getCategory = async (searchFilter?: ICategorySFilter) => {
  try {
    const url = SUB_URL + objectToQueryString(searchFilter || {});
    const response = await instance.get<TApiResponseData<ICategory[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
/**
 * 사업 목록 트리 조회
 */
export const getCategoryTree = async (searchFilter?: ICategorySFilter) => {
  try {
    const url = `${SUB_URL}/tree` + objectToQueryString(searchFilter || {});
    const response = await instance.get<TApiResponseData<ICategory[]>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 상세 조회
 */
export const getDetail = async (categorySid?: number) => {
  try {
    const url = `${SUB_URL}/${categorySid}`;
    const response = await instance.get<TApiResponseData<ICategory>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        sucess: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 등록
 */
export const post = async (data: TCategoryFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const response = await instance.post<TApiResponseData<ICategory>>(
      `${SUB_URL}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};

/**
 * 수정
 */
export const put = async (categorySid: number, data: TCategoryFormData) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const response = await instance.put<TApiResponseData<ICategory>>(
      `${SUB_URL}/${categorySid}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        data: response.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
export const putOrder = async (categorySid: number, data: any) => {
  try {
    const formData = convertDataInfoToFormData(data);
    const response = await instance.put<TApiResponseData<ICategory>>(
      `${SUB_URL}/${categorySid}`,
      formData,
      HEADERS_MULTIPART,
    );

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        data: response.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
/**
 * 삭제
 */
export const remove = async (categorySid?: number) => {
  try {
    const url = `${SUB_URL}/${categorySid}`;
    const response = await instance.delete<TApiResponseData<ICategory>>(url);

    // 성공 시 데이터 반환
    if (response.data.resultCode === 'S' && response.data.data) {
      return {
        success: true,
        data: response.data.data,
      };
    }
  } catch (error) {
    console.error(error);
  }
};
